module.exports = __webpack_public_path__ + "static/media/americanDisposalServices.88aa04af.png";